import { Tooltip } from "@material-ui/core";
import React from "react";

type OnlineOfflineUserBadgeProps = {
  online: boolean;
  isPaused: boolean;
  position: {
    top?: string | number;
    bottom?: string | number;
    left?: string | number;
    right?: string | number;
  };
};

export function OnlineOfflineUserBadge(
  props: OnlineOfflineUserBadgeProps
): JSX.Element {
  const { online, isPaused, position } = props;
  return (
    <Tooltip
      arrow
      title={online ? "Online" : isPaused ? "Em pausa" : "Offline"}
    >
      <div
        className="agent-online"
        style={{
          backgroundColor: online ? "#84fa84" : isPaused ? "#ffe135" : "red",
          position: "absolute",
          width: "15px",
          height: "15px",
          borderRadius: "50%",
          ...position,
        }}
      />
    </Tooltip>
  );
}
